/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25Confira.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function Renegociacao25Confira() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-confira">
        <ContainerHome24>
          <div>
            <h2 className="confira-titulo">
              Confira como o refinanciamento de suas dívidas no Santander é fácil
            </h2>
            <div className="confira-passos">
              <div className="confira-passo">
                <p className="confira-passo-number">1. </p>
                <p className="confira-passo-texto">Clique no botão abaixo e acesse a sua conta;</p>
              </div>
              <div className="confira-passo">
                <p className="confira-passo-number">2. </p>
                <p className="confira-passo-texto">Escolha o contrato que deseja refinanciar;</p>
              </div>
              <div className="confira-passo">
                <p className="confira-passo-number">3. </p>
                <p className="confira-passo-texto">Escolha a oferta que cabe no seu bolso.</p>
              </div>
            </div>
            <RedButton
              href="https://santanderfinanciamentos.com.br/portalcliente/login"
              target="_blank"
              className="confira-btn"
            >
              Renegociar
            </RedButton>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width > 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/renegociacao25/iPhone-desk.webp" />
                  <source type="image/png" srcSet="assets/renegociacao25/iPhone-desk.png" />
                  <img
                    src="assets/renegociacao25/iPhone-desk.png"
                    alt=""
                    className="confira-iphone-desk"
                  />
                </picture>
              )}
            </>
          )}
        </ContainerHome24>

        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width <= 992 && (
              <picture>
                <source type="image/webp" srcSet="assets/renegociacao25/iPhone.webp" />
                <source type="image/png" srcSet="assets/renegociacao25/iPhone.png" />
                <img src="assets/renegociacao25/iPhone.png" alt="" className="confira-iphone" />
              </picture>
            )}
          </>
        )}
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25Confira;
